<ng-container *ngIf="facade.userAuthd$ | async as isAuthd">
  <div class="user-info-container" *ngIf="facade.userClaims$ | async as claims">
    <div class="user-info-icon">
      <mat-icon>person</mat-icon>
    </div>
    <div class="name">
      <div>{{ claims?.name || '' }}</div>
      <div class="company">{{ claims?.customerName || '' }}</div>
    </div>
  </div>
</ng-container>
